import { ColumnFilterItem } from 'antd/es/table/interface';
import { OptionType } from '@components/Select';

export interface AntdOptionType<Value = string> extends Omit<ColumnFilterItem, 'text' | 'value'> {
    text: string;
    value: Value;
}

export function makeOptionType(params: { id: string; name: string }[]): OptionType<string>[] {
    return params.map(param => ({
        value: param.id,
        label: param.name,
    }));
}

export function makeAntdOptionType(params: { id: string; name: string }[]): AntdOptionType[] {
    return params.map(param => ({
        value: param.id,
        text: param.name,
    }));
}

export function parseOptionTypeToAntdOptionType(params: OptionType<string>[]): AntdOptionType[] {
    return params.map(param => ({
        value: param.value,
        text: param.label,
    }));
}

export function parseAntdOptionTypeToOptionType(params: AntdOptionType[]): OptionType<string>[] {
    return params.map(param => ({
        value: param.value,
        label: param.text,
    }));
}
